import actionTypes from "../actionTypes";
import * as zpCDovodUtils from "../../utils/ciselniky/zpCDovodUtils";

export const changeDovod = (dovod) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_DOVOD,
      data: dovod,
    });
  };
};
const getZP_C_DOVOD_Request = () => ({
  type: actionTypes.GET_ZP_C_DOVOD_REQUEST,
});
const getZP_C_DOVOD_Success = (res) => ({
  type: actionTypes.GET_ZP_C_DOVOD_SUCCESS,
  res,
});
const getZP_C_DOVOD_Failure = (error) => ({
  type: actionTypes.GET_ZP_C_DOVOD_FAILURE,
  error,
});
export const getZP_C_DOVOD = () => {
  return async (dispatch) => {
    try {
      dispatch(getZP_C_DOVOD_Request());
      let res = await zpCDovodUtils.getZP_C_DOVOD();
      dispatch(getZP_C_DOVOD_Success(res));
    } catch (error) {
      dispatch(getZP_C_DOVOD_Failure(error));
    }
  };
};
